import React from "react";
import { TextInput, Button, Container, Title, Paper, Stack, Loader } from "@mantine/core";
import { notifications } from "@mantine/notifications";
import { MSIcon } from "components/MSIcon";
import { useTrans } from "core";
import api from "../services/ApiService";
import { useNavigate } from "react-router-dom";
import { Api_Config } from "../../../constants/SubApi.js";

export default function ConfigScreen() {
	const { t } = useTrans();
	const navigate = useNavigate();
	const [confirmPeriod, setConfirmPeriod] = React.useState("");
	const [endNotify, setEndNotify] = React.useState("");
	const [loading, setLoading] = React.useState(true);
	const [saving, setSaving] = React.useState(false);

	React.useEffect(() => {
		loadConfig();
	}, []);

	const loadConfig = async () => {
		try {
			const res = await api.get(`/${Api_Config}`);
			setConfirmPeriod(res.RsvConfirmPeriod);
			setEndNotify(res.RsvEndNotify);
		} catch (err) {
			notifications.show({
				title: t("messages.error"),
				message: t("messages.faliedLoad"),
				color: "red",
			});
		} finally {
			setLoading(false);
		}
	};

	const validate = () => {
		if (!confirmPeriod || !endNotify) {
			notifications.show({
				title: t("messages.error"),
				message: t("config.BothFieldsRequired"),
				color: "red",
			});
			return false;
		}

		const v1 = Number(confirmPeriod);
		const v2 = Number(endNotify);

		if (isNaN(v1) || isNaN(v2)) {
			notifications.show({
				title: t("messages.error"),
				message: t("config.MustBeNumbers"),
				color: "red",
			});
			return false;
		}

		if (v1 < 1 || v1 > 168) {
			notifications.show({
				title: t("messages.error"),
				message: t("config.RsvConfirmPeriodRange"),
				color: "red",
			});
			return false;
		}

		if (v2 < 0 || v2 > 24) {
			notifications.show({
				title: t("messages.error"),
				message: t("config.RsvEndNotifyRange"),
				color: "red",
			});
			return false;
		}

		return true;
	};

	const saveConfig = async () => {
		if (!validate()) return;

		setSaving(true);

		try {
			await api.put(`/${Api_Config}`, {
				RsvConfirmPeriod: Number(confirmPeriod),
				RsvEndNotify: Number(endNotify),
			});

			notifications.show({
				title: t("messages.success"),
				message: t("messages.messagesSuccess"),
				color: "green",
			});
		} catch (err) {
			const msg = err?.data?.message || "messages.error";
			notifications.show({
				title: t("messages.error"),
				message: t(msg),
				color: "red",
			});
		} finally {
			setSaving(false);
		}
	};

	if (loading)
		return (
			<div>
				<Loader size="lg" style={{ display: "block", margin: "100px auto" }} />
			</div>
		);

	return (
		<Container size={500} my={20}>
			<Title order={2} mb={20}>
				{t("drawer.configPage")}
			</Title>

			<Paper shadow="md" p={30} withBorder>
				<Stack spacing={20}>
					<TextInput
						label={t("confing.RsvConfirmPeriod")}
						value={confirmPeriod}
						onChange={(e) => setConfirmPeriod(e.target.value)}
						icon={<MSIcon name="clock" />}
					/>

					<TextInput
						label={t("confing.RsvEndNotify")}
						value={endNotify}
						onChange={(e) => setEndNotify(e.target.value)}
						icon={<MSIcon name="bell" />}
					/>

					<Button onClick={saveConfig} loading={saving} fullWidth>
						{t("confing.save")}
					</Button>

					<Button variant="light" onClick={() => navigate("/")} fullWidth>
						{t("confing.cancel")}
					</Button>
				</Stack>
			</Paper>
		</Container>
	);
}
